<template>
  <header>

    <div class="container">
      <div class="left">
        <h1>Alt kan behandles – og forandringen starter her.</h1>
        <p>
          Med hypnoterapi, selvhypnose og EFT hjelper jeg deg å skape varig endring innenfra. Det handler ikke om å fikse det som er ødelagt, men om å finne tilbake til deg selv – bakenfor gamle mønstre og indre støy – og åpne for klarhet, frihet og indre styrke.
        </p>

        <a href="/booking" class="header-button" >Book en gratis samtale</a>

      </div>

      <div class="right mobile">
        <img src="@/assets/images/roy_in_session.jpg" alt="Therapy Sessions" />

        <!-- Play button overlay -->
        <button class="play-btn" @click="showVideo = true">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.5)"/>
            <polygon points="25,20 45,30 25,40" fill="#fff"/>
          </svg>
        </button>

        <div class="overlay">
          <div class="name">
            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-user"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" /><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /></svg> 
            Charlie
          </div>
          
          <div class="comment">Jeg trodde ikke at det var mulig å bryte ut av angsten, Roy viste meg det motsatte.</div>
        </div>
      </div>
        
    </div>
    
    <div class="right desktop">
      <img src="@/assets/images/roy_in_session.jpg" alt="Therapy Sessions" />

      <!-- Play button overlay -->
      <!-- <button class="play-btn" @click="showVideo = true">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.5)"/>
          <polygon points="25,20 45,30 25,40" fill="#fff"/>
        </svg>
      </button> -->

      <div class="overlay">
        <div class="name">
          <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-user"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" /><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /></svg> 
          Charlie
        </div>
        
        <div class="comment">Jeg trodde ikke at det var mulig å bryte ut av angsten, Roy viste meg det motsatte.</div>
      </div>
    </div>

    <!-- Video overlay -->
    <div v-if="showVideo" class="video-overlay" @click.self="closeVideo">
      <video
        ref="headerVideo"
        src="@/assets/HealingPath_hypno_session.webm"
        controls
        autoplay
        playsinline
        @ended="closeVideo"
      ></video>
      <button class="close-btn" @click="closeVideo">&times;</button>
    </div>
  </header>
</template>

<script setup>
import { ref, watch } from 'vue'
const showVideo = ref(false)
const headerVideo = ref(null)

function closeVideo() {
  showVideo.value = false
  if (headerVideo.value) {
    headerVideo.value.pause()
    headerVideo.value.currentTime = 0
  }
}

// Optional: Autoplay video when overlay opens
watch(showVideo, (val) => {
  if (val && headerVideo.value) {
    headerVideo.value.play()
  }
})
</script>

<style lang="scss">

.mobile {
  display: none; // Hide on desktop
}

.desktop {
  display: block; // Show on desktop
}

@media (max-width: 900px) {
  .mobile {
    display: block; // Show on mobile
  }
  .desktop {
    display: none; // Hide on mobile
  }
}


header {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 80vh;
  position: relative; // make header the positioning context
  background: linear-gradient(300deg,rgba(232, 232, 230, 1) 0%, rgba(216, 213, 207, 1) 50%);

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%; 
    height: 80vh;
    padding: 0; 

    .left {
      display: flex;
      flex: 0 1 50%;
      flex-flow: column;
      justify-content: center;
      color: black;

      padding: 50px;
      background: linear-gradient(300deg,rgba(232, 232, 230, 1) 0%, rgba(216, 213, 207, 1) 50%);
      width: 50%;
      height: 100%;

      position: relative;
      z-index: 1;

      h1 {
        font-size: 2rem;
        margin-bottom: 20px;
        font-weight: 500;
      }

      p {
        font-size: 1.1rem;
        line-height: 1.6;
        color: black;
        max-width: 600px;
      }
      
    }
    
  }

  .right {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 60vw;
    height: 100%;
    background: linear-gradient(-300deg,rgba(232,232,230,1) 0%,rgba(216,213,207,1) 50%);
    z-index: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      filter: contrast(1.1) brightness(0.7) saturate(1.4);
    }

    .overlay {
      position: absolute;
      bottom: 50px;
      right: 15%;
      width: 50%;
      height: 100px;
      border-radius: 20px;
      padding: 20px;
      background: rgba(255, 255, 255, 0.1); // Optional overlay for better text visibility
      background: linear-gradient(180deg,rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
      backdrop-filter: blur(8px);

      @media (max-width: 900px) {
        right: 5%;
        width: 90%;
      }

      
      .name {
        font-family: $merriweather;
        font-size: 0.95rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        font-style: italic;

        svg {
          margin-right: 5px;
        }
      }

      .comment {
        font-size: 0.8rem;
        margin-top: 10px;
        font-weight: 300;
      }
      
    }

    &.mobile {
      padding: 0 !important;
      position: relative !important;
    }

  }

  // Responsive design for smaller screens
  @media (max-width: 900px) {
    padding-top: 70px;
    min-height: 100vh;

    .container {
      flex-direction: column;
      .left, .right {
        width: 100%;
        height: auto;
        position: static;
        padding: 20px;
      }
    }
  }

  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    outline: none;
    transition: transform 0.2s;
    &:hover {
      transform: translate(-50%, -50%) scale(1.1);
    }
  }

  .right {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 60vw;
    height: 100%;
    background: linear-gradient(-300deg,rgba(232,232,230,1) 0%,rgba(216,213,207,1) 50%);
    z-index: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      filter: contrast(1.1) brightness(0.7) saturate(1.4);
    }

    .play-btn {
      // Ensures play button is above image and overlay
      pointer-events: auto;
    }

    .overlay {
      position: absolute;
      bottom: 50px;
      right: 15%;
      width: 50%;
      height: 100px;
      border-radius: 20px;
      padding: 20px;
      background: rgba(255, 255, 255, 0.1); // Optional overlay for better text visibility
      background: linear-gradient(180deg,rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
      backdrop-filter: blur(8px);

      @media (max-width: 900px) {
        right: 5%;
        width: 90%;
      }

      
      .name {
        font-family: $merriweather;
        font-size: 0.95rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        font-style: italic;

        svg {
          margin-right: 5px;
        }
      }

      .comment {
        font-size: 0.8rem;
        margin-top: 10px;
        font-weight: 300;
      }
      
    }

    &.mobile {
      padding: 0 !important;
      position: relative !important;
    }

  }

  // Video overlay styles
  .video-overlay {
    position: fixed;
    z-index: 10000;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.2s;
    video {
      max-width: 90vw;
      max-height: 90vh;
      border-radius: 12px;
      box-shadow: 0 4px 32px rgba(0,0,0,0.5);
      background: #000;
    }
    .close-btn {
      position: absolute;
      top: 30px;
      right: 40px;
      font-size: 3rem;
      color: #fff;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 10001;
      line-height: 1;
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

}
</style>